module.exports = __webpack_public_path__ + "static/media/2v2-chaos-golf-step3.530ad02e.png";